var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDelete(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_32479",
    d: "M83,26.5c-1.8-0.1-3.4,1.2-3.6,3l-4.8,61.8c-0.1,1.1-1,2-2.1,2H27.9c-1.1,0-2.1-0.9-2.1-2 L21,29.6c-0.1-1.8-1.7-3.2-3.6-3c-1.8,0.1-3.2,1.7-3,3.6l4.8,61.8c0.4,4.6,4.2,8.1,8.8,8.1h44.5c4.6,0,8.4-3.5,8.8-8.1l4.8-61.8 C86.2,28.3,84.8,26.7,83,26.5z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_32480",
    d: "M89.4,13.3H64.5V8.8c0-4.8-3.9-8.8-8.8-8.8H44.7c-4.8,0-8.8,3.9-8.8,8.8v4.5H11 c-1.8,0-3.3,1.5-3.3,3.3c0,1.8,1.5,3.3,3.3,3.3c0,0,0,0,0,0h78.3c1.8,0,3.3-1.5,3.3-3.3C92.7,14.7,91.2,13.3,89.4,13.3 C89.4,13.3,89.4,13.3,89.4,13.3L89.4,13.3z M42.5,8.8c0-1.2,1-2.1,2.2-2.2h11.1c1.2,0,2.1,1,2.2,2.2v4.5H42.5L42.5,8.8z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_32481",
    d: "M59.4,86.8c1.8,0,3.2-1.4,3.3-3.2l1.8-47c0-1.8-1.4-3.3-3.2-3.4c-1.8,0-3.3,1.3-3.4,3.1 l-1.8,47c-0.1,1.8,1.4,3.4,3.2,3.4H59.4z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_32482",
    d: "M41.1,86.8h0.1c1.8-0.1,3.3-1.6,3.2-3.4l-1.8-47c-0.1-1.8-1.5-3.2-3.3-3.2h-0.1 c-1.8,0.1-3.3,1.6-3.2,3.4l1.8,47C37.8,85.4,39.3,86.8,41.1,86.8z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelete);
export default __webpack_public_path__ + "static/media/delete.a0d94bd3f6f9d684d77936e4b6191e50.svg";
export { ForwardRef as ReactComponent };